import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { StyleCriteria, StyleScenario, StyleWrapper } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Commande REST de recherche des styles
 */
export class FindStyleCommand extends WizCommand<StyleWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
    const wrapper: StyleWrapper = new StyleWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new StyleScenario();
    wrapper.scenario.manageLines = true;
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();

    wrapper.criteria = new StyleCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    this.configureRemote(ExternalAPI.STYLE_API, wrapper);
  }

  wizResult() {
    super.wizResult();
    if (!!this.result?.entities) {
      this.model.styleEngine.buildMap(this.result.entities);
    }
  }

}
